import { ProductEntity, ProductCategoryEntity } from '../../types';
import { DesignerEntity } from 'src/modules/designers';
import { FilterMenuItem, FiltersCollection } from 'src/modules/form/field/filters/types';

export enum ProductsListingActions {
  FetchFiltersBegin = 'PRODUCTS/LISTING/FETCH_FILTERS/BEGIN',
  FetchFiltersSuccess = 'PRODUCTS/LISTING/FETCH_FILTERS/SUCCESS',
  FetchFiltersError = 'PRODUCTS/LISTING/FETCH_FILTERS/ERROR',
  FetchCategoryBegin = 'PRODUCTS/LISTING/FETCH_CATEGORY/BEGIN',
  FetchCategorySuccess = 'PRODUCTS/LISTING/FETCH_CATEGORY/SUCCESS',
  FetchCategoryError = 'PRODUCTS/LISTING/FETCH_CATEGORYS/ERROR',
  SearchBegin = 'PRODUCTS/LISTING/BEGIN',
  SearchSuccess = 'PRODUCTS/LISTING/SUCCESS',
  SearchError = 'PRODUCTS/LISTING/ERROR',
}

export const productsPerPage = 20;

export interface ProductsListingPaginationType {
  offset: number;
  limit: number;
}

export interface ProductsListingFiltersType extends FiltersCollection {
  locationTypes: FilterMenuItem[];
  productSubcategories: FilterMenuItem[];
  designers: FilterMenuItem[];
}

export interface ProductsListingStore {
  isLoading: boolean;
  isLoaded: boolean;
  error: any;
  errorFilters: boolean;
  isLoadingFilters: boolean;
  isLoadedFilters: any;
  products: ProductEntity[];
  designers: DesignerEntity[];
  productCategory?: ProductCategoryEntity;
  // productSubcategories: ProductSubcategoryEntity[];
  // locationTypes: ProductLocationTypeEntity[];
  pagination: ProductsListingPaginationType;
  /**
   * Filters used to display the products
   */
  filters: ProductsListingFiltersType;
  /**
   * All filters that can be used
   */
  isFiltersDataLoading: boolean;
  filterData: ProductsListingFiltersType;

  searchResultsCount: number;
  loadedListing?: Record<string, ProductsListingStore>;
}
